import React, {useEffect, useState} from "react";
import {SxProps, Tooltip} from "@mui/material";
import Box from "@mui/material/Box";
import {scrollable} from "../../theme";


export default function AbilityIcon(props: {agent_name: string,
    slot: string, abilityState?: {base_charges?: number, max_charges?: number, temporary_charges?: number}, sx? :any, disableTooltip?: boolean}){
    const agentName = props.agent_name || "";
    const slot = props.slot || "";
    const [src, setSrc] = useState(
        `https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${40},w_${40}/v1/valAssets/${agentName.replace('/', '_')}_${slot}.png`
    );
    useEffect(() => {
        setSrc(`https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${40},w_${40}/v1/valAssets/${agentName.replace('/', '_')}_${slot}.png`);
    }, [agentName, slot]);
    const icon = (
        <Box
            component={"img"}
            src={src}
            sx={props.sx}
        />
    );
    if (props.disableTooltip) return icon;
    return <Tooltip title={<Box sx={{ maxWidth: 300, whiteSpace: "pre-wrap", fontSize: "0.7rem", ...scrollable }}>
        {JSON.stringify(props.abilityState, null, 2)}
    </Box>} followCursor={true}>
        {icon}
    </Tooltip>
}

export function ShieldIcon(props: {
    shield: string;
    sx?: SxProps
}){
    const [src, setSrc] = useState(
        `https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${40},w_${40}/v1/valAssets/${props.shield}.png`
    );
    useEffect(() => {
        setSrc(`https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${40},w_${40}/v1/valAssets/${props.shield}.png`);
    }, [props.shield]);


    return <Tooltip title={<Box sx={{ maxWidth: 300, whiteSpace: "pre-wrap", fontSize: "0.7rem", ...scrollable }}>
        {props.shield}
    </Box>} followCursor={true}>
        <Box
            component={"img"}
            src={src}
            sx={props.sx}
        />
    </Tooltip>
}